import type { MouseEvent } from 'react';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

export const trackPartnerImpression = (partnerShortcode: string) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: 'Seller shelf',
    event_label: 'not set',
    event_name: 'view_content',
    content_type: 'seller shelf',
    item_id: partnerShortcode,
  });
};

export const trackPartnerLogoClick = (
  e: MouseEvent<HTMLAnchorElement>,
  partnerShortcode: string,
) => {
  sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_action: 'Partner storefront click',
    event_category: 'Seller shelf',
    event_label: 'partner logo',
    event_name: 'select_content',
    event_details: 'logo click',
    content_type: 'seller shelf',
    item_id: partnerShortcode,
    destination_url: e.currentTarget.getAttribute('href'),
  });
};

export const trackPartnerNameClick = (
  e: MouseEvent<HTMLAnchorElement>,
  partnerShortcode: string,
) => {
  sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_action: 'Partner storefront click',
    event_category: 'Seller shelf',
    event_label: 'partner name',
    event_name: 'select_content',
    event_details: 'link click',
    content_type: 'seller shelf',
    item_id: partnerShortcode,
    destination_url: e.currentTarget.getAttribute('href'),
  });
};

export const trackStorefrontClick = (e: MouseEvent<HTMLAnchorElement>) => {
  sendGALinkClickEvent(e, {
    event: 'custom_event_v2',
    event_name: 'select_content',
    event_details: 'link click',
    item_id: 'discover their story',
    content_type: 'seller shelf',
    destination_url: e.currentTarget.getAttribute('href'),
  });
};

export const trackVisitShopClick = (e: MouseEvent<HTMLAnchorElement>, partnerShortcode: string) => {
  sendGALinkClickEvent(e, {
    event: 'custom_event',
    event_action: 'Partner storefront click',
    event_category: 'Seller shelf',
    event_label: 'visit shop CTA',
    event_name: 'select_content',
    event_details: 'visit shop button click',
    content_type: 'seller shelf',
    item_id: partnerShortcode,
    destination_url: e.currentTarget.getAttribute('href'),
  });
};
